<template>
  <div class="setComponent">
    <!-- 提示栏 -->
    <el-alert
      style="margin:15px 0;"
      :title="$i18n.t('wm_lang_dcc242')+'10'+$i18n.t('wm_lang_a67a18')"
      :closable="false"
      type="info">
    </el-alert>
    <!-- 表单 -->
    <el-form :model="ruleForm" ref="ruleForm" label-width="0" class="form-setting" size="medium">
      <el-form-item>
        <el-button type="primary" @click="addSignature">{{$t("wm_lang_html_4a0838")}}</el-button>
        <!--<el-link>{{$t("wm_lang_html_508db5")}}POP{{$t("wm_lang_html_e9e805")}}</el-link>-->
      </el-form-item>
      <!-- 表格 -->
      <el-form-item>
      <el-table
        size="medium"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          :label="$i18n.t('wm_lang_59592b')">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$i18n.t('wm_lang_be6f79')">
          <template slot-scope="scope">
          <el-switch :value="scope.row.mailAccountDef" @change="changeDefSign(scope.row.signId, $event)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_2b6bc0')"
          width="160">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="previewSign(scope.row.signId)">{{$t("wm_lang_html_645dbc")}}</el-link>
            <el-link type="primary" :underline="false" @click="editSignature(scope.row.signId)">{{$t("wm_lang_html_95b351")}}</el-link>
            <el-link type="danger" :underline="false" @click="deleteSignature(scope.row.signId, scope.row.name)">{{$t("wm_lang_html_2f4aad")}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      </el-form-item>
    </el-form>
    <br><br>
    <el-dialog
      :title="$i18n.t('wm_lang_9034c8')"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      custom-class="import-dialog">
      <div v-html="previewSingCont"></div>
      <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="editSignature(handleSignId)">{{$t("wm_lang_html_95b351")}}</el-button>
    <el-button type="primary" @click="deleteSignature(handleSignId, handleSignName)">{{$t("wm_lang_html_2f4aad")}}</el-button>
    <el-button @click="centerDialogVisible = false">{{$t("wm_lang_html_625fb2")}}</el-button>
  </div>
    </el-dialog>
  </div>
</template>

<script>
import xmail from '@/api/api';
export default {
  name: 'signatureSetting',
  data () {
    return {
      centerDialogVisible: false,
      previewSingCont: '',
      handleSignId: '',
      handleSignName: '',
      // 表格
      tableData: [],
      // 表单
      ruleForm: {
        //
      },
      rules: {
        //
      }
    }
  },
  mounted() {
    this.viewSignatureList();
  },
  methods: {
    htmlToEntity(hStr) {
      let entityMap = {
        '&' : '&amp;',
        '<' : '&lt;',
        '>' : '&gt;',
        '"' : '&quot;',
        "'" : '&apos;'
      };
      let regexp = new RegExp ('['+Object.keys(entityMap).join('')+']','g');
      return hStr.replace(regexp,function(matched){
        return entityMap[matched];
      });
    },
    // 表单
    addSignature() {
      if(this.tableData.length > 9) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_f23656')+'10'+this.$i18n.t('wm_lang_ae4b6b')
        })
        return;
      }
      this.$router.push({name: 'addSignature'});
      this.$EventBus.$emit("updateBreadcrumb",{setBreadcrumb: this.$i18n.t('wm_lang_bffb1c')+'###'+this.$i18n.t('wm_lang_4a0838')});
    },
    editSignature(id) {
      this.$router.push({name: 'addSignature', params: {id: id}});
      this.$EventBus.$emit("updateBreadcrumb",{setBreadcrumb: this.$i18n.t('wm_lang_bffb1c')+'###'+this.$i18n.t('wm_lang_8ea35c')});
    },
    deleteSignature(id, name) {
      this.$confirm(`${this.$i18n.t('custom_lang_0080')}“${this.htmlToEntity(name)}”`, this.$i18n.t('wm_lang_c45357'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Sign.delMailAccountSignParamBuilder();
          pm.signId = id;
          api.Sign.delMailAccountSign(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_0007d1')
              });
              self.viewSignatureList();
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
        this.centerDialogVisible = false;
      }).catch(action => {
        //
      });
    },
    changeDefSign(id, $event) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Sign.updateDefSignParamBuilder();
        pm.signId = id;
        pm.mailAccountDef = $event;
        api.Sign.updateDefSign(pm, function (res) {
          if(res.data.code === 0) {
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_69be67')
            });
            self.viewSignatureList();
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    viewSignatureList() {
      let self = this;
      (function (api, enums, pms) {
        api.Sign.queryAllMailAccountSign({}, function (res) {
          console.log(res.data)
          if(res.data.code === 0) {
            self.tableData = res.data.data;
            // if(Object.keys(res.data.data).length === 0) {
            //   return;
            // }
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    previewSign(id) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Sign.queryMailAccountSignParamBuilder();
        pm.signId = id;
        api.Sign.queryMailAccountSign(pm, function (res) {
          console.log(res.data)
          if(res.data.code === 0) {
            if(Object.keys(res.data.data).length === 0) {
              return;
            }
            // self.$alert(res.data.data.content, 'HTML '+this.$i18n.t('wm_lang_f15261'), {
            //   dangerouslyUseHTMLString: true
            // });
            self.centerDialogVisible = true;
            self.handleSignId = res.data.data.signId;
            self.handleSignName = res.data.data.name;
            self.previewSingCont = res.data.data.content;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 /* .setComponent .title .el-divider--horizontal{margin:10px 0;}
 /deep/ .el-dialog.import-dialog{
   height: auto;
   max-height: 60vh;
   overflow-y: auto;
 }
 /deep/ .el-dialog__body{
   max-height: 50vh!important;
 } */
 /deep/ .el-dialog__body{
   max-height: 50vh!important;height: 50vh!important;overflow-y:auto ;
 }
/deep/ .el-dialog.import-dialog img{max-width:100%;height:auto;}
/deep/ .el-dialog.import-dialog p{padding:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/signatureSetting.vue